(function () {
  'use strict';
  const element = document.getElementById('orli-lp-config');
  if (!element || element.dataset.connected) return;
  element.dataset.connected = 'true';
  const config = JSON.parse(element.textContent);
  const colors = config.colors;
  const keys = Object.keys(colors);
  let selected = keys.find(key => colors[key].handle === config.currentHandle) || keys[0];
  let returnPosition = null;
  try {
    const saved = window.history.state && window.history.state.orliLanding;
    if (saved && saved.handle === config.currentHandle && colors[saved.color]) {
      selected = saved.color;
      if (saved.returning) returnPosition = saved.scrollY;
    }
  } catch (_) {}
  let busy = false;
  let imageRevision = 0;
  const statuses = document.querySelectorAll('[data-checkout-status]');
  const buttons = document.querySelectorAll('[data-buy]');
  const priceFormat = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: config.currency || 'BRL' });
  const money = value => priceFormat.format(value / 100).replace(/\s/g, '').replace(/,00$/, '');
  const root = (config.root || '/').replace(/\/?$/, '/');
  const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'fbclid', 'ttclid', 'sck', 'src'];
  let preparedCart = null;
  let returnDestination = null;
  let returnLabel = 'Ver mais produtos';

  function setupReturnNavigation() {
    const link = document.querySelector('[data-orli-lp-back]');
    if (!link) return;
    const label = link.querySelector('[data-orli-lp-back-label]');
    const home = new URL(root, location.origin);
    const catalog = new URL(root + 'collections', location.origin);
    function allowedSource(value) {
      if (!value) return null;
      try {
        const url = new URL(value, location.origin);
        if (url.origin !== home.origin || url.username || url.password) return null;
        const path = url.pathname.replace(/\/+$/, '') || '/';
        const homePath = home.pathname.replace(/\/+$/, '') || '/';
        const catalogPath = catalog.pathname.replace(/\/+$/, '');
        if (path === homePath || path === catalogPath || path.startsWith(catalogPath + '/')) return url;
      } catch (_) {}
      return null;
    }
    let source = null;
    let savedLabel = null;
    try {
      const saved = window.history.state && window.history.state.orliLanding;
      if (saved && saved.handle === config.currentHandle) {
        source = allowedSource(saved.backUrl);
        if (source && ['Ver mais produtos', 'Voltar ao início', 'Voltar à coleção'].includes(saved.backLabel)) savedLabel = saved.backLabel;
      }
    } catch (_) {}
    source = source || allowedSource(document.referrer);
    const destination = source || catalog;
    returnDestination = destination.href;
    link.href = returnDestination;
    returnLabel = savedLabel || (!source ? 'Ver mais produtos' :
      (source.pathname.replace(/\/+$/, '') === home.pathname.replace(/\/+$/, '') ? 'Voltar ao início' : 'Voltar à coleção'));
    if (label) label.textContent = returnLabel;
    // A native link works with keyboard, modified clicks and new tabs, without
    // stepping back through offer anchors or sending the buyer to an external site.
    remember(false);
  }

  function prepareCart() {
    if (!preparedCart) preparedCart = request(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' }).catch(error => {
      preparedCart = null;
      throw error;
    });
    return preparedCart;
  }

  function remember(returning) {
    try {
      window.history.replaceState({ ...window.history.state, orliLanding: {
        handle: config.currentHandle, color: selected, scrollY: window.scrollY, returning: Boolean(returning), backUrl: returnDestination, backLabel: returnLabel
      } }, '');
    } catch (_) {}
  }

  function restorePosition() {
    if (returnPosition === null) return;
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: returnPosition, behavior: 'instant' });
      returnPosition = null;
      remember(false);
    });
  }

  function warmConnections() {
    if (!document.createElement) return;
    ['https://api.dooki.com.br', 'https://seguro.useorli.com.br'].forEach(origin => {
      const link = document.createElement('link');
      link.rel = 'preconnect'; link.href = origin; link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  function status(message, error) {
    statuses.forEach(node => { node.textContent = message; node.classList.toggle('is-error', Boolean(error)); });
  }

  function render() {
    const color = colors[selected];
    const available = Boolean(color.available && color.id);
    document.documentElement.dataset.variant = selected;
    document.querySelectorAll('.swatch').forEach(button => {
      const data = colors[button.dataset.v];
      if (!data) return;
      const active = button.dataset.v === selected;
      button.classList.toggle('active', active);
      button.classList.toggle('is-sold-out', !data.available);
      button.setAttribute('aria-selected', String(active));
      button.setAttribute('aria-label', data.label + (data.available ? '' : ' — Esgotado'));
      button.title = data.label + (data.available ? '' : ' — Esgotado');
      // Unavailable colors stay selectable for viewing, but can never be purchased.
      button.disabled = busy;
    });
    const offerColor = document.getElementById('offerColorway');
    const buybarColor = document.getElementById('bbColorway');
    const lenses = selected === 'liquid' ? 'Azul' : selected === 'tarta' ? 'Marrom' : 'Verde';
    if (offerColor) offerColor.textContent = color.label + ' · Lente ' + lenses;
    if (buybarColor) buybarColor.textContent = color.label;
    document.querySelectorAll('[data-lp-price]').forEach(node => { node.textContent = color.id ? money(color.price) : 'Indisponível'; });
    document.querySelectorAll('[data-lp-compare]').forEach(node => {
      node.hidden = !(color.compare > color.price);
      node.textContent = money(color.compare);
    });
    document.querySelectorAll('[data-lp-discount]').forEach(node => {
      node.hidden = !(color.compare > color.price);
      node.textContent = (color.compare > 0 ? Math.floor((1 - color.price / color.compare) * 100) : 0) + '% OFF';
    });
    document.querySelectorAll('[data-lp-installments]').forEach(node => { node.textContent = config.installments; });
    document.querySelectorAll('[data-lp-installment]').forEach(node => { node.textContent = money(Math.ceil(color.price / config.installments)); });
    document.querySelectorAll('[data-stock-label]').forEach(node => { node.textContent = available ? config.stockText : 'Esta cor está esgotada no momento'; });
    buttons.forEach((button, index) => {
      if (!button.dataset.originalLabel) button.dataset.originalLabel = index === 0 ? config.buyLabel : 'Comprar';
      button.textContent = busy ? 'Abrindo checkout…' : available ? button.dataset.originalLabel + ' →' : 'Esgotado';
      button.setAttribute('aria-disabled', String(busy || !available));
      button.setAttribute('aria-busy', String(busy));
      button.removeAttribute('target');
      button.href = '#oferta';
    });
    const theme = { liquid: '#10161D', jet: '#0B0D0B', tarta: '#1A130B', copper: '#1A140F', mauve: '#17121F' };
    document.querySelector('meta[name="theme-color"]').content = theme[selected];
  }

  function images() {
    const revision = ++imageRevision;
    document.querySelectorAll('[data-img]').forEach(image => {
      const src = colors[selected].images[image.dataset.img];
      if (!src || image.getAttribute('src') === src) return;
      const next = new Image();
      next.onload = () => { if (imageRevision === revision) { image.src = src; image.style.opacity = '1'; } };
      next.onerror = () => { if (imageRevision === revision) image.style.opacity = '1'; };
      next.src = src;
    });
  }

  async function request(url, options, timeout = 20000) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      let data;
      try { data = await response.json(); } catch (_) { throw new Error('Não foi possível confirmar a resposta da loja. Tente novamente.'); }
      if (!response.ok) {
        const message = response.status === 422 ? 'Esta cor ficou indisponível. Escolha outra cor ou tente novamente.' : 'Não foi possível abrir o checkout. Tente novamente.';
        const error = new Error(message);
        error.status = response.status;
        throw error;
      }
      return data;
    } finally { clearTimeout(timer); }
  }

  async function refresh(key) {
    const color = colors[key];
    try {
      const product = await request(root + 'products/' + encodeURIComponent(color.handle) + '.js', { cache: 'no-store', credentials: 'same-origin' });
      const variant = product.variants.find(item => item.id === color.id) || product.variants.find(item => item.available) || product.variants[0];
      color.available = Boolean(product.available && variant && variant.available);
      color.id = variant ? variant.id : 0;
      color.price = variant ? variant.price : 0;
      color.compare = variant ? variant.compare_at_price || 0 : 0;
      return color;
    } catch (error) {
      if (error.status === 404) { color.available = false; color.id = 0; return color; }
      throw error;
    }
  }

  function track() {
    try {
      const params = new URLSearchParams(location.search);
      const saved = new URLSearchParams(readCookie('utmsTrack'));
      trackingKeys.forEach(key => { if (params.has(key)) saved.set(key, params.get(key)); });
      document.cookie = 'utmsTrack=' + saved.toString() + '; max-age=2592000; path=/; SameSite=Lax; Secure';
    } catch (_) {}
  }

  function readCookie(name) {
    const pair = document.cookie.split('; ').find(value => value.startsWith(name + '='));
    return pair ? pair.slice(name.length + 1) : '';
  }

  function checkoutUrl(value) {
    const url = new URL(value);
    if (url.protocol !== 'https:' || !['seguro.useorli.com.br'].includes(url.hostname)) {
      throw new Error('Não foi possível confirmar o endereço seguro do checkout. Tente novamente ou fale com a Orli.');
    }
    const saved = new URLSearchParams(readCookie('utmsTrack'));
    trackingKeys.forEach(key => { if (saved.has(key)) url.searchParams.set(key, saved.get(key)); });
    const ga = readCookie('_ga');
    if (ga) url.searchParams.set('_ga', ga);
    return url.href;
  }

  async function buy(event) {
    event.preventDefault();
    if (busy || !colors[selected].available || !colors[selected].id) return;
    const key = selected;
    const previousPrice = colors[key].price;
    let temporaryLine = null;
    let cleanupTask = null;
    let destination = null;
    busy = true;
    render();
    status('Confirmando preço e disponibilidade…');
    try {
      const color = colors[key];
      if (!color.available) throw new Error('Esta cor está esgotada. Escolha outra cor disponível.');
      const cart = await prepareCart();
      // A hidden temporary line validates Shopify stock without showing any cart UI.
      // The Yampi payload contains only this purchase; existing cart items are retained.
      const stamp = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      const added = await request(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: color.id, quantity: 1, properties: { _orli_lp: stamp } }] })
      });
      const item = added.items && added.items.find(line => line.properties && line.properties._orli_lp === stamp);
      temporaryLine = item && item.key;
      if (!item || item.quantity !== 1 || item.variant_id !== color.id) throw new Error('Não foi possível confirmar o produto. Tente novamente.');
      temporaryLine = item.key;
      // The add response is authoritative for stock and the current Shopify price.
      // A separate product request here would repeat the same validation.
      if (item.original_price !== previousPrice) {
        color.price = item.original_price;
        try { await refresh(key); } catch (_) {}
        throw new Error('O preço foi atualizado pela loja. Confira o novo valor e clique novamente para continuar.');
      }
      const payload = {
        ...cart,
        items: [item], item_count: 1,
        total_price: item.final_line_price,
        original_total_price: item.original_line_price,
        items_subtotal_price: item.final_line_price,
        total_discount: item.original_line_price - item.final_line_price,
        total_weight: item.grams,
        cart_level_discount_applications: []
      };
      status('Abrindo o checkout seguro da Yampi…');
      const checkoutTask = request('https://api.dooki.com.br/v2/public/shopify/cart', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ shop: 'useorli.com.br', shopify_internal_domain: config.shopDomain, cart_payload: payload })
      });
      // Yampi maps the item from the explicit payload. Clean up this exact temporary
      // line while the mapping request runs, keeping the customer's cart intact.
      cleanupTask = request(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: temporaryLine, quantity: 0 })
      }, 3000).catch(() => null);
      const result = await checkoutTask;
      if (!result.active || !result.checkout_direct_url) throw new Error('O checkout está temporariamente indisponível. Tente novamente ou fale com a Orli.');
      destination = checkoutUrl(result.checkout_direct_url);
    } catch (error) {
      if (error.status === 422) { try { await refresh(key); } catch (_) {} }
      status(error.name === 'AbortError' ? 'A conexão demorou mais que o esperado. Tente novamente.' : error.message || 'Não foi possível abrir o checkout. Tente novamente.', true);
    } finally {
      if (temporaryLine) {
        try {
          await (cleanupTask || request(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: temporaryLine, quantity: 0 }) }, 3000));
        } catch (_) { /* Never clear or replace the customer's existing cart. */ }
      }
      busy = false;
      render();
    }
    if (destination) { remember(true); location.assign(destination); }
  }

  document.querySelectorAll('.swatch').forEach(button => {
    button.addEventListener('click', () => {
      if (busy || !colors[button.dataset.v]) return;
      selected = button.dataset.v;
      remember(false);
      status(''); render(); images();
      refresh(selected).then(() => render()).catch(() => {});
    });
  });
  buttons.forEach(button => button.addEventListener('click', buy));
  function refreshAll() { if (!busy) Promise.all(keys.map(key => refresh(key).catch(() => {}))).then(render); }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { preparedCart = null; prepareCart().catch(() => {}); refreshAll(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) { busy = false; preparedCart = null; prepareCart().catch(() => {}); render(); refreshAll(); } restorePosition(); });
  setupReturnNavigation(); track(); warmConnections(); render(); images(); restorePosition(); prepareCart().catch(() => {}); refreshAll();
})();
